import { useEffect, useState } from 'react';
import { Table, Button, Badge, Alert, Spinner, Modal, Form, Row, Col } from 'react-bootstrap';
import { api } from '../api/client';
import { formatDate } from '../shared/dateFormat';

export default function TeacherStudents() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState({ type: '', text: '' });
  const [attendFor, setAttendFor] = useState(null);

  const load = async () => {
    setLoading(true);
    try { setRows(await api.get('/teacher/students')); }
    catch (e) { setMsg({ type: 'danger', text: e.message }); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  if (loading) return <div className="text-center py-5"><Spinner /></div>;

  return (
    <>
      <h3 className="mb-4">My Students</h3>
      {msg.text && <Alert variant={msg.type} dismissible onClose={() => setMsg({ type: '', text: '' })}>{msg.text}</Alert>}
      {rows.length === 0 ? (
        <Alert variant="info">No active students yet.</Alert>
      ) : (
        <Table bordered hover responsive className="bg-white">
          <thead className="table-dark"><tr><th>Student</th><th>Phone</th><th>Email</th><th>Grade</th><th>Since</th><th>Fee</th><th>Classes</th><th>Status</th><th>Actions</th></tr></thead>
          <tbody>
            {rows.map((s) => (
              <tr key={s.hire_id}>
                <td>{s.student_name}</td>
                <td>{s.phone || '-'}</td>
                <td>{s.email}</td>
                <td>{s.grade || '-'}</td>
                <td>{formatDate(s.start_date)}</td>
                <td>₹{Number(s.monthly_fee).toFixed(0)}</td>
                <td>{s.classes_taken}</td>
                <td><Badge bg={s.status === 'active' ? 'success' : 'secondary'}>{s.status}</Badge></td>
                <td><Button size="sm" variant="primary" onClick={() => setAttendFor(s)}>Attendance</Button></td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      {attendFor && <AttendanceModal hire={attendFor} onClose={() => setAttendFor(null)} onChange={load} />}
    </>
  );
}

function AttendanceModal({ hire, onClose, onChange }) {
  const today = new Date().toISOString().slice(0, 10);
  const [rows, setRows] = useState([]);
  const [date, setDate] = useState(today);
  const [status, setStatus] = useState('present');
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const load = async () => {
    try { setRows(await api.get(`/teacher/hires/${hire.hire_id}/attendance`)); }
    catch (e) { setErr(e.message); }
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    setBusy(true); setErr('');
    try {
      await api.post('/teacher/attendance', { hire_id: hire.hire_id, date, status, note });
      setNote('');
      await load();
      onChange();
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  };

  return (
    <Modal show onHide={onClose} size="lg" centered scrollable>
      <Modal.Header closeButton><Modal.Title>Attendance — {hire.student_name}</Modal.Title></Modal.Header>
      <Modal.Body>
        {err && <Alert variant="danger">{err}</Alert>}
        <Row className="g-2 align-items-end mb-3">
          <Col md={3}><Form.Group><Form.Label>Date</Form.Label><Form.Control type="date" value={date} onChange={(e) => setDate(e.target.value)} /></Form.Group></Col>
          <Col md={3}><Form.Group><Form.Label>Status</Form.Label><Form.Select value={status} onChange={(e) => setStatus(e.target.value)}><option>present</option><option>absent</option><option>cancelled</option></Form.Select></Form.Group></Col>
          <Col md={4}><Form.Group><Form.Label>Note</Form.Label><Form.Control value={note} onChange={(e) => setNote(e.target.value)} /></Form.Group></Col>
          <Col md={2}><Button onClick={save} disabled={busy} className="w-100">{busy ? '...' : 'Save'}</Button></Col>
        </Row>
        <h6>History</h6>
        {rows.length === 0 ? <p className="text-muted small">No attendance marked yet.</p> : (
          <Table size="sm" bordered><thead><tr><th>Date</th><th>Status</th><th>Note</th></tr></thead>
            <tbody>{rows.map((a) => <tr key={a.id}><td>{formatDate(a.date)}</td><td><Badge bg={a.status === 'present' ? 'success' : a.status === 'absent' ? 'danger' : 'secondary'}>{a.status}</Badge></td><td>{a.teacher_note || '-'}</td></tr>)}</tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer><Button onClick={onClose} variant="secondary">Close</Button></Modal.Footer>
    </Modal>
  );
}
